import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import { htmlLang, loadHost } from './kit/index.ts';
import './kit/kit.css';
import './styles.css';

document.documentElement.lang = htmlLang();
const root = document.getElementById('root');
if (root === null) throw new Error('index.html has no #root');
// Which group's own host this is, if any, decides which pages match: asked once, before the first render.
await loadHost();
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
